import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { authentication } from '@biz-action/user-actions/auth-login.actions';
import { Store } from '@ngrx/store';
import { PasswordValidator } from '../password.validator';
import { ForgetPasswordService } from '../services/forget-password.service';

@Component({
	selector: 'app-reset-password',
	templateUrl: './reset-password.component.html',
	styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
	resetPasswordForm: UntypedFormGroup;
	submitted = false;

	constructor(
		private formBuilder: UntypedFormBuilder,
		private route: ActivatedRoute,
		private router: Router,
		private resetpasswordService: ForgetPasswordService,
		private store: Store,
	) {}

	ngOnInit(): void {
		this.resetPasswordForm = this.formBuilder.group(
			{
				email: ['', Validators.required],
				password: ['', [Validators.required, Validators.minLength(6)]],
				password_confirmation: ['', Validators.required],
				token: ['', Validators.required],
			},
		/* 	{
				validator: PasswordValidator('password', 'password_confirmation'),
			}, */
		);
		this.route.queryParamMap.subscribe((params) => {
			if (params.get('email')) {
				this.resetPasswordForm.controls['email'].setValue(params.get('email'));
			}
			if (params.get('token')) {
				this.resetPasswordForm.controls['token'].setValue(params.get('token'));
			}
		});
	}

	get resetPass() {
		return this.resetPasswordForm.controls;
	}

	onSubmit() {
		if (this.resetPasswordForm.invalid) {
			this.resetPasswordForm.markAllAsTouched();
			return;
		}

		/* this.resetpasswordService.resetPassword(this.resetPasswordForm.value).subscribe((resp: any) => {
			if (resp.code_status == 200 && resp.data) {
				if (window.confirm('Password reset successful! Return to login page now.')) {
					this.router.navigate(['/login']);
				}
				this.submitted = true;
				console.log(resp.data);
				// this.router.navigate(['/login']);
			}
		}); */

		this.store.dispatch(authentication.resetpassword(this.resetPasswordForm.value));
	}
}
